export enum ShipmentType {
    Truck    = 0,
    Container   = 1
}

export const ShipmentTypeMetadata = {
    '0': {
        display: 'Truck',
        value: 0
    },
    '1': {
        display: 'Container',
        value: 2
    }
};
